<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="about">
      <div class="main-content">
        <!-- title and content -->
        <div class="page-width pre-formatted padding">
          <div class="section-header text-center">
            <h2>{{ $t("companyInformationTitle") }}</h2>
          </div>
          <!-- <p v-html="$t('companyInformationBody')"></p> -->
        </div>
        <!-- image -->

        <div class="pre-formatted">
          <ul>
            <li>
              <img src="../assets/img/companyinfo.png" alt="" />
            </li>
          </ul>
        </div>
        <p>
          {{ $t("companyInforP1") }}
        </p>
        <p>
          {{ $t("companyInforP2") }}
        </p>
        <p>
          {{ $t("companyInforP3") }}
        </p>
        <p>
          {{ $t("companyInforP4") }}
        </p>
        <p>
          {{ $t("companyInforP5") }}
        </p>
        <p>{{ $t("companyInforP6") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "../components/breadcrumb";

export default {
  name: "about",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: this.$t("aboutUs"),
    };
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/about.vue